/*
Copyright (c) 2012-2026 Grab Taxi Holdings PTE LTD (GRAB), All Rights Reserved.
NOTICE: All information contained herein is, and remains the property of GRAB.
The intellectual and technical concepts contained herein are confidential,
proprietary and controlled by GRAB and may be covered by patents, patents in process,
and are protected by trade secret or copyright law.

You are strictly forbidden to copy, download, store (in any medium), transmit, disseminate,
adapt or change this material in any way unless prior written permission is obtained from GRAB.
Access to the source code contained herein is hereby forbidden to anyone except current GRAB
employees or contractors with binding Confidentiality and Non-disclosure agreements explicitly
covering such access.

The copyright notice above does not evidence any actual or intended publication or disclosure of
this source code, which includes information that is confidential and/or proprietary,
and is a trade secret, of GRAB.

ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC PERFORMANCE, OR PUBLIC DISPLAY OF OR
THROUGH USE OF THIS SOURCE CODE WITHOUT THE EXPRESS WRITTEN CONSENT OF GRAB IS STRICTLY PROHIBITED,
AND IN VIOLATION OF APPLICABLE LAWS AND INTERNATIONAL TREATIES. THE RECEIPT OR POSSESSION OF THIS
SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS TO REPRODUCE,
DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT MAY DESCRIBE,
IN WHOLE OR IN PART.
*/
import React from "react"
import { Select, Tooltip } from "@duxton-web/ui"
import { Form } from "grab-ui"
import styles from "./AttributeDrawer.modules.css"

export interface TaggingFieldOption {
  label: string
  value: number
}

export interface TaggingFieldProps {
  containerRef: React.Ref<HTMLDivElement>
  dataTestId?: string
  form: FormComponentProps["form"]
  fieldName: string
  label: React.ReactNode
  initialValue?: number
  options: TaggingFieldOption[]
  placeholder?: string
  onChange: (value: number) => void
  showTooltip: boolean
  tooltipText: string
  onTooltipOpenChange: (open: boolean) => void
}

// Shared yes/no tagging question (alcohol / tobacco) in the attribute drawer:
// a decorated form select plus the one-time info tooltip anchored to it.
const TaggingField = ({
  containerRef,
  dataTestId,
  form,
  fieldName,
  label,
  initialValue,
  options,
  placeholder,
  onChange,
  showTooltip,
  tooltipText,
  onTooltipOpenChange,
}: TaggingFieldProps) => {
  const { getFieldDecorator } = form

  return (
    <div
      ref={containerRef}
      className={styles.taggingField}
      data-testid={dataTestId}
    >
      <Form.Item label={label}>
        {getFieldDecorator(fieldName, { initialValue })(
          <Select
            style={{ width: "100%" }}
            placeholder={placeholder}
            onChange={onChange}
          >
            {options.map(({ value, label: optionLabel }) => (
              <Select.Option key={value} value={value}>
                {optionLabel}
              </Select.Option>
            ))}
          </Select>,
        )}
      </Form.Item>
      <Tooltip
        placement="bottomLeft"
        title={tooltipText}
        defaultOpen
        open={showTooltip}
        onOpenChange={onTooltipOpenChange}
        destroyTooltipOnHide
        trigger="click"
      >
        <div className={styles.tooltipAnchor} />
      </Tooltip>
    </div>
  )
}

export default TaggingField
